import { trpc } from '../lib/trpc';
import { Wizard } from './CreateWizard';
import { Button, Table } from '@mantine/core';
import { modals } from '@mantine/modals';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { ulid } from 'ulid';
import { useLocation } from 'wouter';

dayjs.extend(localizedFormat);

export const Models = () => {
  const modelsQuery = trpc.models.list.useQuery();
  const [, navigate] = useLocation();

  return (
    <div className="w-full p-5">
      <Button
        onClick={() => {
          const modalId = ulid();
          modals.open({
            children: <Wizard modalId={modalId} />,
            modalId,
            size: 'xl',
            title: <strong>Create content type</strong>,
          });
        }}
      >
        Add
      </Button>
      <Table
        highlightOnHover
        striped
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Type</Table.Th>
            <Table.Th>Fields</Table.Th>
            <Table.Th>Updated</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {modelsQuery.data?.map((row) => (
            <Table.Tr
              className="cursor-pointer"
              key={row.models.id}
              onClick={() => navigate(`/models/${row.models.id}`)}
            >
              <Table.Td>{row.models.name}</Table.Td>
              <Table.Td>{row.models.type}</Table.Td>
              <Table.Td>{row.models.schema?.fields.length + 1 || 1}</Table.Td>
              <Table.Td>{dayjs(row.models.updatedAt).format('L LT')}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};
